export const STEP_SEND_PASSWORD_RESET_LINK = 'STEP_SEND_PASSWORD_RESET_LINK';
export const STEP_SEND_PASSWORD_RESET_LINK_SUCCESS = 'STEP_SEND_PASSWORD_RESET_LINK_SUCCESS';
export const STEP_RESET_PASSWORD = 'STEP_RESET_PASSWORD';
export const STEP_RESET_PASSWORD_SUCCESS = 'STEP_RESET_PASSWORD_SUCCESS';

export const SOURCE_APP_ADAPP = 'adapp';
export const SOURCE_APP_BSS = 'bss';
